import { render } from "./BackdropDialogCloseSuccess.vue?vue&type=template&id=99b25364"
import script from "./BackdropDialogCloseSuccess.vue?vue&type=script&lang=js"
export * from "./BackdropDialogCloseSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__